import { useState } from "react";
import { ChevronDown, ChevronRight, Gem } from "lucide-react";
import ImageLightbox from "./ImageLightbox";

// Collapsible panel showing the customer's DIY bracelet design on an order row.
export default function BraceletDesignPanel({ design }) {
    const [open, setOpen] = useState(false);
    const [zoom, setZoom] = useState(false);
    const img = design.design_image_url || "";
    const slots = design.crystal_slots || [];

    return (
        <div className="border-t border-slate-200 bg-purple-50/40" data-testid="bracelet-design-panel">
            <button
                type="button"
                data-testid="bracelet-design-toggle"
                onClick={() => setOpen(!open)}
                className="w-full px-4 py-2.5 flex items-center gap-2 text-left hover:bg-purple-50"
            >
                {open ? <ChevronDown className="h-3.5 w-3.5 text-purple-700" /> : <ChevronRight className="h-3.5 w-3.5 text-purple-700" />}
                <Gem className="h-3.5 w-3.5 text-purple-700" />
                <span className="text-xs font-semibold uppercase tracking-wider text-purple-700">手链设计</span>
                {img && (
                    <img
                        src={img}
                        alt="手链设计"
                        data-testid="bracelet-design-thumb"
                        onClick={(e) => { e.stopPropagation(); setZoom(true); }}
                        className="h-[50px] w-[80px] object-cover rounded border border-purple-200 cursor-zoom-in hover:ring-2 hover:ring-purple-300"
                    />
                )}
                <span className="text-xs text-slate-500 ml-auto">
                    {design.wrist_cm || "—"} cm · {design.bead_mm || "—"} mm · {slots.length} 颗水晶
                </span>
            </button>

            {open && (
                <div className="px-4 pb-4 grid grid-cols-1 md:grid-cols-[200px_1fr] gap-4">
                    {img ? (
                        <img
                            src={img}
                            alt="手链设计大图"
                            data-testid="bracelet-design-large"
                            onClick={() => setZoom(true)}
                            className="w-full max-w-[200px] rounded-lg border border-purple-200 bg-white cursor-zoom-in"
                        />
                    ) : (
                        <div className="text-xs text-slate-400">（无设计图）</div>
                    )}
                    <div className="text-xs text-slate-600 space-y-2">
                        <div className="grid grid-cols-2 gap-x-6 gap-y-1">
                            <div>天珠：<span className="text-slate-900 font-medium">{design.dzi_name || "—"}</span></div>
                            <div>天珠 SKU：<span className="font-mono text-slate-900">{design.dzi_sku || "—"}</span></div>
                            <div>手腕围：<span className="text-slate-900 font-medium">{design.wrist_cm || "—"} cm</span></div>
                            <div>珠径：<span className="text-slate-900 font-medium">{design.bead_mm || "—"} mm</span></div>
                            <div>总珠位：<span className="text-slate-900 font-medium">{design.total_slots || slots.length}</span></div>
                            <div>提交时间：<span className="font-mono text-slate-900">{(design.submitted_at || "").slice(0, 16).replace("T", " ")}</span></div>
                        </div>
                        <div>
                            <div className="font-semibold text-purple-700 mb-1">水晶明细</div>
                            <ol className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-0.5 list-decimal list-inside">
                                {slots.map((s, i) => (
                                    <li key={`${s.crystal_id}-${i}`} className="flex items-center gap-1.5">
                                        <span
                                            className="inline-block h-2.5 w-2.5 rounded-full border border-slate-300 shrink-0"
                                            style={{ background: s.crystal_color || "#ddd" }}
                                        />
                                        <span className="text-slate-800">{s.crystal_name || "—"}</span>
                                        {s.side && <span className="text-slate-400">({s.side})</span>}
                                    </li>
                                ))}
                                {slots.length === 0 && <li className="text-slate-400">—</li>}
                            </ol>
                        </div>
                    </div>
                </div>
            )}

            <ImageLightbox open={zoom && !!img} images={img ? [img] : []} title={`手链设计 · ${design.dzi_name || ""}`} onClose={() => setZoom(false)} />
        </div>
    );
}
